import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/useAppStore';
import { useSettingsStore } from '../../store/useSettingsStore';
import { useRole } from '../../hooks/useRole';
import { filterOffersForStock } from '../../utils/stockUtils';
import Badge from '../ui/Badge';

function SpecialsTab() {
  const { t } = useTranslation();
  const role = useRole();
  const config = useAppStore((state) => state.config);
  const rerollLuckyOffer = useAppStore((state) => state.rerollLuckyOffer);
  const form = useSettingsStore((state) => state.form);
  const setForm = useSettingsStore((state) => state.setForm);

  const offers = filterOffersForStock(config?.offers, config);
  const locked = role === 'anonymous';

  const applyOffer = (offerName) => {
    const offer = offers.find((e) => e.name === offerName);
    if (!offer) return;
    setForm((c) => ({ ...c, offer: offer.name, toppings: [...offer.toppings] }));
  };

  const personalizeOffer = (offerName) => {
    applyOffer(offerName);
    setForm((c) => ({ ...c, menuTab: 'personalized' }));
  };

  return (
    <>
      <div className="space-y-1.5">
        {offers.map((offer) => (
          <button
            key={offer.name}
            type="button"
            disabled={locked}
            className={`w-full rounded-lg border px-4 py-3 text-left transition disabled:cursor-not-allowed disabled:opacity-40 ${
              form.offer === offer.name
                ? 'border-emerald-500/60 bg-emerald-500/10'
                : 'border-[color:var(--app-border)] bg-[color:var(--app-surface)] hover:border-emerald-500/40'
            }`}
            onClick={() => applyOffer(offer.name)}
          >
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-semibold">{offer.name}</span>
              {offer.alias && (
                <Badge toneClass="border-[color:var(--app-border)] uppercase tracking-wide theme-muted">
                  {t(`alias.${offer.alias.toLowerCase()}`, { defaultValue: offer.alias })}
                </Badge>
              )}
              {form.offer === offer.name && (
                <Badge toneClass="border-emerald-500/40 bg-emerald-500/15 theme-accent">
                  {t('specials.selected')}
                </Badge>
              )}
            </div>
            <p className="mt-0.5 text-sm theme-muted">{offer.toppings.join(', ')}</p>
            {offer.random && (
              <span
                role="link"
                tabIndex={0}
                onClick={(event) => {
                  event.stopPropagation();
                  rerollLuckyOffer();
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    event.stopPropagation();
                    rerollLuckyOffer();
                  }
                }}
                className={`mt-1 inline-block text-sm theme-accent underline underline-offset-2 ${locked ? 'opacity-40' : 'cursor-pointer hover:opacity-80'}`}
              >
                {t('specials.reroll')}
              </span>
            )}
          </button>
        ))}
      </div>

      <button
        type="button"
        disabled={locked || !form.offer}
        onClick={() => personalizeOffer(form.offer)}
        className={`w-full rounded-lg border py-2.5 text-sm font-semibold transition disabled:cursor-not-allowed ${
          form.offer && !locked
            ? 'border-emerald-500/50 theme-accent hover:bg-emerald-500/8'
            : 'opacity-40 theme-muted'
        }`}
      >
        {form.offer ? t('specials.personalize', { offer: form.offer }) : t('specials.personalizeEmpty')}
      </button>
    </>
  );
}

export default SpecialsTab;